/**
 * @fileoverview GET handler for the "/:app_group_id/braze_mcp/tools" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdBrazeMcpTools } from "./constants";
import type { GetAppGroupIdBrazeMcpToolsResult } from "./types";
import { isGetAppGroupIdBrazeMcpToolsResult } from "./validators";

export const getAppGroupIdBrazeMcpTools = reactQueryFetcherAdapter(
  appGroupIdBrazeMcpTools,
  (signal: AbortSignal, appGroupId: string): Promise<GetAppGroupIdBrazeMcpToolsResult> => {
    // Tool discovery runs in the background on every page load, and a failure here
    // costs the user nothing: Operator simply registers no MCP tools and carries on
    // with its own. Propagating the error would escalate an unreachable MCP server
    // into a blocking "Unexpected Error" modal in front of a page the user was
    // using for something else entirely.
    return fetch(`/${appGroupId}/braze_mcp/tools`, "GET", {}, { signal }, { propagateFetchRequestError: false });
  },
  isGetAppGroupIdBrazeMcpToolsResult
);
